import React, {useEffect, useState} from 'react';
import {IOtherDestination} from "../../../../../../utils/interfaces/my_documents/fiscal_registry/IOtherDestination";
import {IFiscalRegistry} from "../../../../../../utils/interfaces/my_documents/fiscal_registry/IFiscalRegistry";
import useApiGetOtherDestination from "./api-hooks/useApiGetOtherDestination";
import {Box} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import LabelledMuiTypography from "../../../../../ui/mui/mui-display-data/LabelledMuiTypography";
import {useTranslation} from "react-i18next";
import Typography from "@mui/material/Typography";


interface Props {
    obj: IOtherDestination | undefined,
    fiscal_registry: IFiscalRegistry | undefined,
}

const OtherDestinationCard = ({
                                  obj: initialObj,
                                  fiscal_registry,
                              }: Props) => {


    const theme = useTheme();
    const {t} = useTranslation();
    const [obj, setObj] = useState<IOtherDestination | undefined>(initialObj)

    useEffect(() => {
        if (initialObj) {
            setObj(initialObj)
        }
    }, [initialObj]);


    const {
        data: detailedObj,
    } = useApiGetOtherDestination(fiscal_registry?.id, obj?.id);

    useEffect(() => {
        if (detailedObj) {
            setObj(detailedObj);
        }
    }, [detailedObj]);


    return (
        <>
            <Box sx={{
                marginTop: 1,
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                border: '1px solid lightgrey',
                borderRadius: '4px',
                padding: '10px',
                backgroundColor: theme.palette.backgroundAppGarageColor.gray_50,

            }}>
                <Typography
                    variant="subtitle2"
                    sx={{
                        color: theme.palette.primary.main,
                        position: 'absolute',
                        top: -12,
                        left: 0,
                        backgroundColor: 'transparent',
                        paddingX: 2,
                    }}
                >
                    {t('Other Destination')}
                </Typography>
                <LabelledMuiTypography label={'business_name'} value={obj?.business_name} upperCaseValue={true}/>
                <LabelledMuiTypography label={'address'} value={obj?.address} upperCaseValue={true}/>
                <LabelledMuiTypography label={'cap'} value={obj?.cap} upperCaseValue={true}/>
                <LabelledMuiTypography label={'city'} value={obj?.city} upperCaseValue={true}/>
                <LabelledMuiTypography label={'state'} value={obj?.nation.name} upperCaseValue={true}/>
            </Box>
        </>

    );
}

export default OtherDestinationCard;